import { render, staticRenderFns } from "./PageGov.vue?vue&type=template&id=2f02e74c&scoped=true&"
import script from "./PageGov.vue?vue&type=script&lang=js&"
export * from "./PageGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f02e74c",
  null
  
)

export default component.exports